import React, { useState } from "react";
import CustomFilters from "../../../core/custom-filters";
import { Box } from "@mui/material";
import SiTextField from "../../../core/si-textfield";
import { PAGE_LIMIT } from "../../../utils";

const KnowledgeSharingFilters = ({ loadData }) => {
  const [filterType, setFilterType] = useState("");
  const [filterValue, setFilterValue] = useState("");
  const [endDate, setEndDate] = useState("");

  const applyFilters = (filters) => {
    if (Object.keys(filters).length) {
      const payload = {};
      for (let key in filters) {
        if (key === "createdAt") {
          payload["startDate"] = filters[key];
          if (endDate) {
            payload["endDate"] = endDate;
          }
        } else {
          payload[key] = filters[key];
        }
      }

      loadData({
        ...payload,
        sortBy: "-createdAt",
        limit: PAGE_LIMIT,
        page: 1,
      });
    } else {
      loadData({ sortBy: "-createdAt", limit: PAGE_LIMIT, page: 1 });
    }
  };

  const filterTypes = [
    { label: "Filter by Topic", value: "topic" },
    { label: "Filter by Date", value: "createdAt" },
  ];

  const renderFilterInput = () => {
    switch (filterType) {
      case "topic":
        return (
          <SiTextField
            placeholder="Topic"
            name="topic"
            onChange={handleFilterValueChange}
          />
        );
      case "createdAt":
        return (
          <Box sx={{ display: "flex", gap: "20px" }}>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>Start Date</p>
              <SiTextField
                placeholder="Start Date"
                name="startDate"
                type="date"
                onChange={handleFilterValueChange}
                sx={{ mt: 1 }}
              />
            </div>
            <div>
              <p style={{ margin: "0px", fontWeight: 500 }}>End Date</p>
              <SiTextField
                placeholder="End Date"
                name="endDate"
                type="date"
                onChange={(e) => setEndDate(e.target.value)}
                sx={{ mt: 1 }}
              />
            </div>
          </Box>
        );
      default:
        return null;
    }
  };

  const handleFilterValueChange = (event) => {
    setFilterValue(event.target.value);
  };

  return (
    <div>
      <CustomFilters
        applyFilters={applyFilters}
        renderFilterInput={renderFilterInput}
        filterTypes={filterTypes}
        filterType={filterType}
        setFilterType={setFilterType}
        filterValue={filterValue}
        setFilterValue={setFilterValue}
      />
    </div>
  );
};

export default KnowledgeSharingFilters;
